// extracted by mini-css-extract-plugin
export default {"join":"join_join__bOfJ+","joinItem":"join_joinItem__e6Y0k","joinContent":"join_joinContent__iUw+y","joinTitle":"join_joinTitle__p6fsg","joinText":"join_joinText__0DOAU"};